import React, {useState} from 'react'
import {useTranslation} from 'react-i18next'
import {useHistory, useLocation} from 'react-router-dom'
import {makeStyles} from '@material-ui/core'
import CardWithTitle from 'components/atoms/CardWithTitle'
import NoticeConfirmDialog from 'components/Dialog/NoticeConfirmDialog'
import PageTable from 'pages/Analysis/EEGSummary/PageTable'
import FiveIndicators from 'pages/Analysis/EEGSummary/Component/FiveIndicators'
import BrainFunctionConnectivity from 'pages/Analysis/EEGSummary/Component/BrainFunctionConnectivity'
import EEGSummaryReportStyle from 'pages/Analysis/EEGSummary/style'
import {
  EEG_SUMMARY_TABS,
  TYPE_REPORT,
} from 'pages/Analysis/EEGSummary/constants'

const useStyles = makeStyles(EEGSummaryReportStyle)
function EEGSummary() {
  const {t} = useTranslation()
  const classes = useStyles()
  const history = useHistory()
  const location = useLocation()
  const [tabActive, setTabActive] = useState<number>(
    TYPE_REPORT.BRAIN_FUNCTION_MAPPING,
  )

  return (
    <>
      <CardWithTitle>
        <div className={`${classes.heathTabs}`}>
          {EEG_SUMMARY_TABS.map((item) => (
            <div
              className={`${classes.heathTab} ${
                tabActive === item.id && classes.heathTabActive
              }`}
              onClick={() => {
                setTabActive(item.id)
                history.replace({pathname: location.pathname})
              }}
              aria-hidden='true'
              key={item.id}
            >
              {t(item.label)}
            </div>
          ))}
        </div>

        {tabActive === TYPE_REPORT.BRAIN_FUNCTION_MAPPING && (
          <PageTable
            isActive={tabActive === TYPE_REPORT.BRAIN_FUNCTION_MAPPING}
          />
        )}
        {tabActive === TYPE_REPORT.FIVE_INDICATORS && (
          <FiveIndicators
            isActive={tabActive === TYPE_REPORT.FIVE_INDICATORS}
          />
        )}
        {tabActive === TYPE_REPORT.BRAIN_FUNCTION_CONNECTIVITY && (
          <BrainFunctionConnectivity
            isActive={tabActive === TYPE_REPORT.BRAIN_FUNCTION_CONNECTIVITY}
          />
        )}
      </CardWithTitle>
      <NoticeConfirmDialog />
    </>
  )
}

export default EEGSummary
